import { Trans } from '@lingui/macro'
import { Alert, AlertTitle, Typography } from '@mui/material'
import { usePendingJoinRequests } from 'app/EgretLayout/Layout1/usePendingJoinRequests'
import React from 'react'

const typeToConnectPrompLabel = {
  funding: <Trans>FUNDING_NOT_CONNECTED_TO_ORGANIZATION_BANNER_INFO</Trans>,
  sat: <Trans>SAT_NOT_CONNECTED_TO_ORGANIZATION_BANNER_INFO</Trans>
}

const typeToRequestPendingLabel = {
  funding: <Trans>JOIN_REQUEST_PENDING_BANNER_INFO</Trans>,
  sat: <Trans>SAT_JOIN_REQUEST_PENDING_BANNER_INFO</Trans>
}

export const NotConnectedToOrgBanner: React.FC<{ type?: 'funding' | 'sat' }> = ({ type = 'funding' }) => {
  const { pendingJoinRequests } = usePendingJoinRequests()

  if (pendingJoinRequests == null) {
    return null
  }

  return (
    <Alert variant='filled' severity='info'>
      <AlertTitle>
        <Trans>
          NOT_CONNECTED_TO_ORGANIZATION_BANNER
        </Trans>
      </AlertTitle>
      <Typography>
        {pendingJoinRequests.length > 0
          ? typeToRequestPendingLabel[type]
          : typeToConnectPrompLabel[type]}
      </Typography>
    </Alert>
  )
}
